module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/60.d5bcdaf7.png";